import React from "react";
import { Modal } from "react-bootstrap";

const ViewPDFModal = ({ url, show, onHide, key }) => {
  const ext = url?.split(/[#?]/)[0].split(".").pop().trim();

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        animation={true}
        style={{ border: `0` }}
        centered
        dialogClassName="modalW trailerWrapper h-50"
        contentClassName="trailer"
        className="modal-dialog-scrollable"
      >
        <Modal.Header closeButton>
          <h5 className="modal-title fs-20 fw-500" id="ViewPDFLabel">
            View Document
          </h5>
        </Modal.Header>

        <Modal.Body>
          <div className="">
            {ext === "pdf" ? (
              <iframe
                src={`${url}#view=fitH`}
                // src={url}
                width="100%"
                height="400"
                frameBorder="0"
              ></iframe>
            ) : (
              <img
                src={`${url}#view=fitH`}
                // src={url}
                width="100%"
                height="400"
                frameBorder="0"
              ></img>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className="btn btn-styletwo"
            data-bs-dismiss="modal"
            onClick={onHide}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewPDFModal;
